export const IS_LOCAL_ENV = !!window.location.hostname?.startsWith?.('localhost');

export const IS_TESTING_ENVIRONMENT =
  // running the code locally
  process.env.NODE_ENV === 'development' ||
  // test pages
  !!window.location.hostname?.startsWith?.('oneaudi-feature-app') ||
  !!window.location.hostname?.includes?.('dev.collab') ||
  !!window.location.hostname?.includes?.('prod.collab') ||
  // query parameter
  !!window.location.hostname?.startsWith?.('qa');

export const IS_PROD_ENV =
  (!window.location.hostname.includes('oneaudi-falcon-teams') ||
    !window.location.hostname?.startsWith?.('qa')) &&
  new URLSearchParams(window.location.search).get('environment') !== 'development';

export const IS_TIER_1 =
  window.location.hostname.includes('audiusa.com') ||
  window.location.hostname.includes('audi.ca') ||
  window.location.pathname.includes('tier-1') ||
  (IS_LOCAL_ENV && !window.location.pathname.includes('tier-3'));

export const ZIPCODE_DATA_LOCAL_STORAGE_KEY = 'ZipCodeData';

export const GRAPHQL_GATEWAY_URL = IS_PROD_ENV
  ? 'https://api.audiusa.com/graphql'
  : 'https://qa-api.audiusa.com/graphql';

export const IS_STAGING_PAGE = window.location.href.includes('staging');

export const TEST_ZIP_VALIDATION = new URLSearchParams(window.location.search).has('testLambda');

export const OFFER_MONTH =
  new URLSearchParams(window.location.search).get('offerMonth') ?? undefined;

// TODO: remove! This is temp solution for Ghost Launch
export const SHOULD_RENDER_OFFERS =
  new URLSearchParams(window.location.search).get('showoffers') === 'ghost';

export const PARTNER_ID =
  new URLSearchParams(window.location.search).get('partner_id') ?? undefined;

export const GEO_ZIP_URL_PARAM =
  new URLSearchParams(window.location.search).get('geoZip') ?? undefined;
